<template>
  <div v-click-outside="hideDropdown">
    <hr>
    <div class="uk-width-1-1 filter-heading">
      <span class="filter-title uk-text-bottom">{{filterTitle}}</span>
      <span v-if="!expanded" class="see-more-triangle uk-float-right uk-text-top"
            uk-icon="icon: triangle-down; ratio: 1.50" @click="setExpanded"></span>
      <span v-else class="see-more-triangle uk-float-right uk-text-top" uk-icon="icon: triangle-up; ratio: 1.50"
            @click="setExpanded"></span>
    </div>

    <div v-if="!expanded">
      <div v-for="option in displayFilters" class="options-padding">
        <span v-if="!option.selected" class=" uk-text-middle add-pointer" @click="onOptionSelected(option)">
          <img :data-src="STD_UNCHECKED_BOX"
               class="std-checkbox"
               uk-img>
        </span>
        <span v-else class="uk-text-middle add-pointer" @click="onOptionSelected(option)">
          <img :data-src="STD_CHECK_BOX"
               class="std-checkbox"
               uk-img>
        </span>
        <span class="filter-options add-pointer" @click="onOptionSelected(option)">{{resolveTitle(option)}}</span>
      </div>
    </div>

    <div v-else v-bind:id="filterTitle" class="select-filters-container bottom-margin overlay">
      <div v-for="option in displayFilters">
        <div class="select-filters">
                      <span v-if="option.selected">
            <span class="uk-text-middle add-pointer" @click="onOptionSelected(option)">
              <img :data-src="LRG_CHECKED_BOX" class="lrg-checkbox"
                   uk-img></span>
            <span class="filter-options add-pointer uk-text-bold"
                  @click="onOptionSelected(option)">{{resolveTitle(option)}}</span>
          </span>
          <span v-else>
             <span class="uk-text-middle add-pointer" @click="onOptionSelected">
               <img :data-src="LRG_UNCHECKED_BOX" class="lrg-checkbox"
                    uk-img></span>
            <span class="filter-options add-pointer" @click="onOptionSelected(option)">{{resolveTitle(option)}}</span>
          </span>
        </div>
      </div>
    </div>
    <span v-if="!expanded" class="see-more-text" @click="setExpanded">+ {{$t('general.seeMore')}}</span>
    <span v-else class="see-more-text" @click="setExpanded">- {{$t('general.seeLess')}}</span>
  </div>
</template>

<script>
    import iconUtil from '../../../utils/icon-util'
    import * as misc from '../../../enums/misc'
    import ClickOutside from 'vue-click-outside'
    import {SUPPORTED_COUNTRIES} from '../../../enums/supported-countries'
    import * as _ from 'lodash'

    export default {
      name: 'moderation-filters',
      props: ['filters', 'state'],
      data() {
        return {
          expanded: false,
          dropdownClicked: false,
          STD_CHECK_BOX: iconUtil.resolve(misc.STD_CHECKED),
          STD_UNCHECKED_BOX: iconUtil.resolve(misc.STD_UNCHECKED),
          LRG_CHECKED_BOX: iconUtil.resolve(misc.LRG_CHECKED),
          LRG_UNCHECKED_BOX: iconUtil.resolve(misc.LRG_UNCHECKED)
        }
      },
      methods: {
        setExpanded() {
          if (this.expanded) {
            this.expanded = false
          } else {
            this.expanded = true
          }
                // required to get the clickOutside directive to function
          this.dropdownClicked = true
          setTimeout(() => {
            this.dropdownClicked = false
          }, 100)
        },
        hideDropdown() {
          if (!this.dropdownClicked) {
            if (this.expanded) {
              this.expanded = false
            }
          }
        },
        resolveTitle(option) {
          if (this.filterTitle === 'Location') {
            let countryTitle = SUPPORTED_COUNTRIES.find(c => c.ID === option.title).title
            return '[' + option.count + '] ' + this.$t('countries')[countryTitle.toLowerCase()]
          } else {
            return option.title
          }
        },
        onOptionSelected(option) {
          this.$emit('onOptionSelected', {filter: this.filters.title, title: option.title})
        }
      },
      computed: {
        displayFilters() {
          if (!this.expanded) {
            return _.orderBy(this.filters.items, ['count'], 'desc').slice(0, 4)
          } else {
            return _.orderBy(this.filters.items, ['count'], 'desc')
          }
        },
        filterTitle() {
          if (this.filters.title === 'pending locations' || this.filters.title === 'declined locations') {
            return this.$t('general.location')
          } else {
            return this.filters.title
          }
        }
      },
      directives: {
        ClickOutside
      }
    }
</script>

<style lang="scss" scoped>
  @import '../../../../src/styles/colours.scss';

  hr {
    background: $slate;
    opacity: 0.2;
    height: 2px;
    margin-bottom: 10px;
  }

  .bottom-margin {
    margin-bottom: 14px;
  }

  .filter-heading {
    height: 30px;
    margin-bottom: 16px;
  }

  .filter-options {
    font-size: 15px;
    padding-left: 5px;
  }

  .filter-title {
    font-size: 18px;
    color: $content-text;
    line-height: 30px;
    padding-left: 5px;
  }

  .lrg-checkbox {
    height: 29px;
    width: 29px;
  }

  .options-padding {
    padding-bottom: 14px;
  }

  .see-more-triangle {
    color: $light-blue;
    cursor: pointer;
  }

  .see-more-text {
    color: $content-link-blue;
    cursor: pointer;
    font-size: 14px;
    padding-top: 14px;
  }

  .std-checkbox {
    height: 22px;
    width: 22px;
  }


</style>
